"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aggregateRules = exports.mergeAggregatedRulesDecl = exports.getStaticComputedCSS = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@stylable/core");
var css_selector_tokenizer_1 = require("css-selector-tokenizer");
var stylable_shorthands_1 = require("./stylable-shorthands");
var match_selector_parts_1 = require("./aggregation-tools/match-selector-parts");
var selector_specificity_1 = require("./aggregation-tools/selector-specificity");
var stylable_aggregation_constants_1 = require("./stylable-aggregation-constants");
function getStaticComputedCSS(stylable, sheets, selector, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.filterDecl, filterDecl = _c === void 0 ? stylable_aggregation_constants_1.DEFAULT_FILTER : _c, _d = _b.useRawDecl, useRawDecl = _d === void 0 ? false : _d, _e = _b.disableBackgroundShorthand, disableBackgroundShorthand = _e === void 0 ? false : _e;
    var nonScopedMatchingRules = aggregateRules(stylable.createTransformer(), sheets[0].getMeta(), selector, {});
    for (var i = 1; i < sheets.length; i++) {
        var shallowMatching = aggregateRules(stylable.createTransformer(), sheets[i].getMeta(), selector, {}, true);
        nonScopedMatchingRules.unshift(shallowMatching[0]);
    }
    return mergeAggregatedRulesDecl(function (meta, decl, overrides) { return (0, core_1.evalDeclarationValue)(stylable.resolver, decl.value, meta, decl, overrides); }, filterScope(nonScopedMatchingRules, sheets[0].getActiveScopes()), filterDecl, useRawDecl, disableBackgroundShorthand);
}
exports.getStaticComputedCSS = getStaticComputedCSS;
function filterScope(matchingRules, scopes) {
    return matchingRules.map(function (chunk) {
        return chunk.filter(function (_a) {
            var _b, _c;
            var rule = _a.rule;
            var stScopeSelector = rule.stScopeSelector;
            if (stScopeSelector) {
                return scopes.has("@st-scope ".concat(stScopeSelector));
            }
            if (((_b = rule.parent) === null || _b === void 0 ? void 0 : _b.type) === 'root') {
                return true;
            }
            if (((_c = rule.parent) === null || _c === void 0 ? void 0 : _c.type) === 'atrule' &&
                scopes.has("@".concat(rule.parent.name, " ").concat(rule.parent.params))) {
                return true;
            }
            return false;
        });
    });
}
function getCommentedDeclValue(decl) {
    if (~stylable_aggregation_constants_1.PROPS_SUPPORTING_COMMENTS.indexOf(decl.prop)) {
        var valueWithComments = '';
        var raws = decl.raws;
        if (raws.value && raws.value.raw) {
            valueWithComments = raws.value.raw;
        }
        if (raws.between && raws.between.match(stylable_aggregation_constants_1.COMMENT_START_IN_RAWS_BETWEEN_REGEX)) {
            valueWithComments = raws.between.slice(1).trim() + (valueWithComments || decl.value);
        }
        if (valueWithComments) {
            return decl.clone({ value: valueWithComments });
        }
    }
    return decl;
}
function sortBySpecificity(chunk) {
    var options = { stylableMode: true };
    return chunk.sort(function (a, b) {
        var aSelectors = a.rule.selectors;
        var bSelectors = b.rule.selectors;
        if (aSelectors.length !== 1 || bSelectors.length !== 1) {
            throw new Error('only single selector is supported for sorting');
        }
        var sA = (0, selector_specificity_1.calculateSpecificity)(aSelectors[0], options);
        var sB = (0, selector_specificity_1.calculateSpecificity)(bSelectors[0], options);
        return (0, selector_specificity_1.matchSpecificity)(sA, sB);
    });
}
function mergeAggregatedRulesDecl(evalDeclarationValue, matchingRules, filterDecl, useRawDecl, disableBackgroundShorthand) {
    var e_1, _a;
    if (filterDecl === void 0) { filterDecl = stylable_aggregation_constants_1.DEFAULT_FILTER; }
    if (useRawDecl === void 0) { useRawDecl = false; }
    if (disableBackgroundShorthand === void 0) { disableBackgroundShorthand = false; }
    var l = matchingRules.length;
    var decls = {};
    var declsOrder = [];
    var short = new stylable_shorthands_1.StylableShorthands();
    var all = [];
    while (l--) {
        all.push.apply(all, tslib_1.__spreadArray([], tslib_1.__read(matchingRules[l]), false));
    }
    var allSorted = sortBySpecificity(all);
    var _loop_1 = function (meta, rule, overrides) {
        rule.walkDecls(function (decl) {
            var _a, e_2, _b;
            decl = getCommentedDeclValue(decl);
            var evaluated = useRawDecl ? decl.value : evalDeclarationValue(meta, decl, overrides);
            var shorts = useRawDecl
                ? (_a = {}, _a[decl.prop] = evaluated, _a) : short.expandDeclaration(decl.clone({ value: evaluated }), undefined, undefined, disableBackgroundShorthand);
            try {
                for (var _c = (e_2 = void 0, tslib_1.__values(Object.entries(shorts))), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var _e = tslib_1.__read(_d.value, 2), key = _e[0], val = _e[1];
                    if (filterDecl(key)) {
                        decls[key] = val;
                        declsOrder.push([key, val, meta, rule, overrides]);
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                }
                finally { if (e_2) throw e_2.error; }
            }
        });
    };
    try {
        for (var allSorted_1 = tslib_1.__values(allSorted), allSorted_1_1 = allSorted_1.next(); !allSorted_1_1.done; allSorted_1_1 = allSorted_1.next()) {
            var _b = allSorted_1_1.value, meta = _b.meta, rule = _b.rule, overrides = _b.overrides;
            _loop_1(meta, rule, overrides);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (allSorted_1_1 && !allSorted_1_1.done && (_a = allSorted_1.return)) _a.call(allSorted_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return { decls: decls, declsOrder: declsOrder };
}
exports.mergeAggregatedRulesDecl = mergeAggregatedRulesDecl;
function aggregateRules(transformer, rootMeta, selector, overrides, shallow) {
    if (overrides === void 0) { overrides = {}; }
    if (shallow === void 0) { shallow = false; }
    var selectorElements = transformer.resolveSelectorElements(rootMeta, selector)[0];
    var elStateMapping = extractElementStateMapping(selector);
    if (selectorElements.length !== elStateMapping.length) {
        throw new Error('Unsupported Selector provided this algorithm only support .x:state1:state2::y:state1:state2::z:state1:state2 like structure');
    }
    var matchingRules = [];
    selectorElements.forEach(function (_a, i) {
        var resolved = _a.resolved;
        var resolvedToAggregate = shallow ? resolved.slice(0, 1) : resolved;
        resolvedToAggregate.forEach(function (_a) {
            var meta = _a.meta, symbol = _a.symbol;
            var matchingSelector = getMatchingSelector(symbol, elStateMapping, i);
            var matchingSelectorAst = (0, css_selector_tokenizer_1.parse)(matchingSelector);
            var ruleChunk = [];
            meta.ast.walkRules(function (rawRule) {
                // multiple selector support by splitting the rules into single selector rules
                rawRule.selectors.forEach(function (selector) {
                    var stScopeSelector = rawRule.stScopeSelector;
                    var rule = rawRule.clone({ selector: selector, parent: rawRule.parent });
                    var currentSelector = stScopeSelector ? selector.slice(stScopeSelector.length + 1) : selector;
                    if ((0, match_selector_parts_1.matchSelectorPartsWithStates)(matchingSelectorAst, (0, css_selector_tokenizer_1.parse)(currentSelector))) {
                        var mixins = getRuleMixins(rule);
                        if (mixins) {
                            handleMixins(rule, meta, overrides, mixins, transformer, elStateMapping, i, ruleChunk);
                        }
                        else {
                            ruleChunk.push({
                                meta: meta,
                                rule: rule,
                                overrides: overrides,
                            });
                        }
                    }
                });
            });
            matchingRules.push(ruleChunk);
        });
    });
    return matchingRules;
}
exports.aggregateRules = aggregateRules;
function extractElementStateMapping(selector) {
    return selector.split('::').map(function (part) {
        var _a = tslib_1.__read(part.split(':')), el = _a[0], states = _a.slice(1);
        return {
            el: el,
            states: states,
        };
    });
}
function getMatchingSelector(symbol, elStateMapping, i) {
    var prefix = symbol._kind === 'class' ? '.' : '';
    var matchingSelector = prefix +
        elStateMapping
            .slice(i)
            .map(function (part, idx) {
            var statePart = part.states.length ? ":".concat(part.states.join(':')) : '';
            var elPart = idx === 0 ? symbol.name : part.el;
            return elPart + statePart;
        })
            .join('::');
    return matchingSelector;
}
/* Stylable Mixins Helpers */
function handleMixins(rule, meta, overrides, mixins, transformer, elStateMapping, elementIndex, ruleChunk) {
    if (!rule.nodes) {
        throw new Error("Missing nodes in rule ".concat(rule.toString()));
    }
    var mixinDecls = rule.nodes.filter(function (node) {
        return node.type === 'decl' && node.prop === '-st-mixin';
    });
    /*
      We can maybe resolve this throw by taking the last mixin decl.
      since it's a bad practice to use multiple -st-mixin decls in the same rule we are not supporting it.
    */
    if (mixinDecls.length !== 1) {
        throw new Error("Only support one -st-mixin declaration found ".concat(mixinDecls.toString()));
    }
    var index = rule.nodes.indexOf(mixinDecls[0]);
    var beforeMixin = rule.nodes.slice(0, index + 1);
    var afterMixin = rule.nodes.slice(index + 1);
    var rootRules = [
        {
            meta: meta,
            rule: rule.clone({ nodes: beforeMixin, parent: rule.parent }),
            overrides: overrides,
        },
    ];
    var afterRootRules = [
        {
            meta: meta,
            rule: rule.clone({ nodes: afterMixin, parent: rule.parent }),
            overrides: overrides,
        },
    ];
    mixins.forEach(function (mix) {
        var resolvedMixin = resolveMixin(transformer, mix, meta);
        if (!resolvedMixin) {
            throw new Error("Failed to resolve mixin ".concat(JSON.stringify(mix.ref)));
        }
        if ((resolvedMixin === null || resolvedMixin === void 0 ? void 0 : resolvedMixin._kind) === 'css') {
            if (resolvedMixin.symbol._kind === 'class' || resolvedMixin.symbol._kind === 'element') {
                var singleEl = [elStateMapping.slice(elementIndex)[0]];
                var matchingMixinSelector = getMatchingSelector(resolvedMixin.symbol, singleEl, 0);
                if (Array.isArray(mix.mixin.options)) {
                    throw new Error('Only named mixin arguments are supported');
                }
                // this assumes that the mixin has only one chunk
                var mixinRulesChunks = aggregateRules(transformer, resolvedMixin.meta, matchingMixinSelector, tslib_1.__assign(tslib_1.__assign({}, mix.mixin.options), overrides));
                if (mixinRulesChunks.length > 1) {
                    throw new Error('aggregate mixin rules only support one mixin chunk');
                }
                var mixinRules = mixinRulesChunks[0];
                processMixinsSelectors(rule, matchingMixinSelector, mixinRules);
                // this assumes the first rule of a mixin is the root
                var _a = tslib_1.__read(mixinRules), mixinRoot = _a[0], otherRules = _a.slice(1);
                mixinRoot.rule.parent = rule.parent;
                rootRules.push(mixinRoot);
                afterRootRules.push.apply(afterRootRules, tslib_1.__spreadArray([], tslib_1.__read(otherRules), false));
            }
        }
    });
    ruleChunk.push.apply(ruleChunk, tslib_1.__spreadArray([], tslib_1.__read(rootRules), false));
    ruleChunk.push.apply(ruleChunk, tslib_1.__spreadArray([], tslib_1.__read(afterRootRules), false));
}
function resolveMixin(transformer, mix, meta) {
    var symbol = meta.mappedSymbols[mix.mixin.type];
    if (symbol && (symbol._kind === 'class' || symbol._kind === 'element')) {
        var res = {
            _kind: 'css',
            meta: meta,
            symbol: symbol,
        };
        return res;
    }
    else {
        return transformer.resolver.deepResolve(mix.ref);
    }
}
function processMixinsSelectors(rootRule, matchingMixinSelector, mixinRules) {
    var prefixType = (0, css_selector_tokenizer_1.parse)(matchingMixinSelector).nodes[0].nodes[0];
    mixinRules.forEach(function (_a) {
        var rule = _a.rule;
        rule.selector = rule.selectors
            .map(function (selector) {
            var targetSelector = (0, css_selector_tokenizer_1.stringify)(destructiveReplaceNode((0, css_selector_tokenizer_1.parse)(selector), prefixType, {
                type: 'invalid',
                value: '&',
            }));
            return (0, core_1.scopeSelector)(rootRule.selector, targetSelector).selector;
        })
            .join(',');
    });
}
function destructiveReplaceNode(ast, matchNode, replacementNode) {
    (0, match_selector_parts_1.walkNodes)(ast, function (node) {
        if (node.type === matchNode.type && node.name === matchNode.name) {
            node.type = 'selector';
            node.nodes = [replacementNode];
        }
    });
    return ast;
}
function getRuleMixins(rule) {
    return rule.mixins;
}
//# sourceMappingURL=get-static-computed-css.js.map